import { Link } from "react-router-dom";
import { ArrowUpRight, Plus } from "lucide-react";
import { toast } from "sonner";
import { PageHeader } from "../components/site/PageHeader";
import { DishGrid } from "../components/site/DishCard";
import { OfferBanner } from "../components/site/OfferBanner";
import { Reveal } from "../components/site/Reveal";
import { useContent, usePizzas } from "../lib/content";
import { useCart } from "../lib/cart";
import { formatPrice, restaurant } from "../data/siteData";

export const Supplements = () => {
  const { content } = useContent();
  const s = content?.supplements;
  if (!s) return null;
  return (
    <div className="flex flex-wrap items-center gap-3 text-sm text-[#D6CFC0]" data-testid="pizza-supplements">
      <span className="text-[11px] uppercase tracking-[0.25em] text-[#D4A359]">Suppléments</span>
      {Object.entries(s).map(([k, v]) => (
        <span key={k} className="inline-flex items-center gap-1 rounded-full border border-[#D4A359]/30 px-3 py-1"><Plus className="w-3 h-3" /> {v.label.replace("Supplément ", "")} {formatPrice(v.price)}</span>
      ))}
    </div>
  );
};

export default function PizzasPage() {
  const { status } = useContent();
  const pizzas = usePizzas();
  const { add } = useCart();
  const onAdd = (p) => {
    add(p.id);
    toast.success(`${p.name} ajoutée au panier`);
  };
  return (
    <>
      <PageHeader testId="pizzas-header" eyebrow={pizzas.length ? `${pizzas.length} recettes` : "La pizzeria"} lines={["Nos", <em key="p" className="text-[#E5B66C]">pizzas</em>]} intro="Les pizzas de CAP SUD, pizzeria à Morangis : choisissez vos pizzas et ajoutez-les au panier pour un retrait au restaurant." />
      <OfferBanner testId="pizzas-offer-banner" />
      <section className="py-14 sm:py-20" data-testid="pizzas-grid">
        <div className="container-site">
          <div className="mb-10"><Supplements /></div>
          {status === "error" && <p className="text-[#F0A385]" data-testid="pizzas-error">La liste des pizzas est momentanément indisponible. Appelez-nous au {restaurant.phone}.</p>}
          <DishGrid items={pizzas} onAdd={onAdd} />
          <Reveal className="mt-16">
            <div className="rounded-3xl border border-[#D4A359]/25 bg-[#123322] p-8 sm:p-12 flex flex-col md:flex-row md:items-center justify-between gap-6">
              <div>
                <h2 className="font-display text-3xl sm:text-4xl">Prêt à commander ?</h2>
                <p className="mt-2 text-[#D6CFC0]">Click & Collect : commandez en ligne, payez et récupérez au restaurant.</p>
              </div>
              <Link to="/commander-a-emporter" className="btn-gold self-start md:self-auto" data-testid="pizzas-order-cta">Commander à emporter <ArrowUpRight className="w-4 h-4" /></Link>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
